export const MOBILE_WIDTH = 1000;
export const DRAWER_WIDTH = 240;
export const ORGANIZATION_QUERY_KEY = "organizations";
export const TIPO_ACTIVIDAD_QUERY_KEY = "activityTypes";
export const TIPO_DOCUMENTO_QUERY_KEY = "documentTypes";
